<template>
  <div>
    <el-form
      ref="jxsqForm"
      :rules="rules"
      label-width="120px"
      :hide-required-asterisk="false"
    >
      <div class="card">
        <el-row>
          <el-col :span="24" class="label">{{ baseInfo.courseName }}</el-col>
        </el-row>
        <el-row class="card_content">
          <el-col :span="12">
            <span>课题负责人:</span>
            <span>{{ baseInfo.courseLeaderName }}</span>
          </el-col>
          <el-col :span="12">
            <span>课题主要成员:</span>
            <span>{{ baseInfo.memberName }}</span>
          </el-col>
        </el-row>
        <div>
          <div class="btn">
            <el-button
              type="primary"
              icon="el-icon-upload"
              size="small"
              @click="handleToUpload"
              >上传附件</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-download"
              size="small"
              @click="handleToDownload"
              >下载模板</el-button
            >
          </div>
        </div>
      </div>

      <div
        class="card card3"
        v-if="baseInfo.metaPropList && baseInfo.metaPropList.length > 0"
      >
        <el-row>
          <el-col :span="24" class="label">研究方案</el-col>
        </el-row>
        <el-row>
          <el-col
            :span="24"
            v-for="(item2, index2) in baseInfo.metaPropList"
            :key="index2"
          >
            <div class="content">
              <div v-if="item2.type == 1">
                <div class="content_title">
                  <span v-if="item2.required == '1'" class="red">*</span>
                  <span>{{ item2.cname }}</span>
                </div>
                <div class="content_text">
                  <el-input
                    v-model="item2.propValue"
                    type="textarea"
                    :autosize="{ minRows: 6 }"
                    show-word-limit
                  ></el-input>
                </div>
              </div>
              <div v-else>
                <div class="content_title">
                  <span v-if="item2.required == '1'" class="red">*</span>
                  <span>{{ item2.cname }}</span>
                </div>
                <div :id="`wangEditor_jxsq_form_${index2}`"></div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="card card4" v-if="feedbackList.length > 0">
        <el-row>
          <el-col :span="24" class="label">意见反馈处理情况</el-col>
          <div class="card4_div">
            <el-col>
              <el-radio-group v-model="baseInfo.feedbackType">
                <el-radio label="1">意见反馈已处理完毕</el-radio>
                <el-radio label="2">暂时不处理</el-radio>
              </el-radio-group>
            </el-col>
            <el-col>
              <el-table
                :max-height="height"
                :data="feedbackList"
                fit
                highlight-current-row
                :default-sort="{ prop: 'date', order: 'descending' }"
                tooltip-effect="dark"
              >
                <el-table-column
                  label="状态"
                  align="left"
                  prop="status"
                  min-width="120px"
                  :show-overflow-tooltip="true"
                />

                <el-table-column
                  label="反馈人"
                  align="left"
                  prop="ygbh"
                  min-width="120px"
                  :show-overflow-tooltip="true"
                />
                <el-table-column
                  label="反馈时间"
                  align="left"
                  prop="feedbackTime"
                  min-width="150px"
                  :show-overflow-tooltip="true"
                />
                <el-table-column
                  label="意见反馈"
                  align="left"
                  prop="content"
                  min-width="250px"
                  :show-overflow-tooltip="true"
                />
                <template slot="empty">
                  <div class="nodata">
                    <img src="@/img/nodata.png" alt="" width="160" />
                    <div>暂无数据</div>
                  </div>
                </template>
              </el-table>
            </el-col>
          </div>
        </el-row>
      </div>
    </el-form>
    <el-dialog
      title="课题结果查看"
      :visible.sync="handleResultDialog"
      width="90%"
      v-if="handleResultDialog"
      :closeOnClickModal="false"
      append-to-body
    >
      <CourseResult :mxParams="mxParams"></CourseResult>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleResultDialog = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import wangEditor from "wangeditor";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import moment from "moment";
import { mapGetters } from "vuex";
import { getCourseJxsqFormInfo, insertClosingInfo } from "@/api/course.js";
// import CourseResult from "../result.vue";

export default {
  components: { Treeselect, CourseResult: () => import("../result.vue") },
  computed: {
    ...mapGetters(["deptUser", "user"]),
  },
  props: ["mxParams"],
  data() {
    return {
      addDialog: false,
      editDialog: false,
      baseInfo: {
        metaPropList: [],
      },
      height: 500,
      rules: {},
      cyList: [
        {
          name: "",
        },
      ],

      editorList: [],
      editForm: {},
      handleResultDialog: false,
      feedbackList: [],
    };
  },
  created() {
    this.getData();
  },
  mounted() {
    const timer = setInterval(() => {
      if (this.baseInfo.metaPropList && this.baseInfo.metaPropList.length > 0) {
        for (let i in this.baseInfo.metaPropList) {
          if (this.baseInfo.metaPropList[i].type == 2) {
            let editor = new wangEditor(`#wangEditor_jxsq_form_${i}`);
            editor = this.editorConfig(editor);
            if (this.baseInfo.metaPropList[i].propValue) {
              editor.txt.html(this.baseInfo.metaPropList[i].propValue);
            } else {
              editor.txt.html(this.baseInfo.metaPropList[i].defaultValue);
            }
            this.editorList.push(editor);
          } else {
            if (!this.baseInfo.metaPropList[i].propValue) {
              this.baseInfo.metaPropList[i].propValue =
                this.baseInfo.metaPropList[i].defaultValue;
            }
          }
        }
        clearInterval(timer);
      }
    }, 50);
  },

  methods: {
    editorConfig(editor) {
      editor.config.placeholder = "请输入内容";
      editor.config.height = 300;
      //editor.config.uploadImgShowBase64 = true
      editor.config.uploadImgMaxSize = 10 * 1024 * 1024; //图片大小10M
      editor.config.uploadImgMaxLength = 1;
      editor.config.uploadFileName = "file"; //上传参数 自定义
      editor.config.uploadImgTimeout = 60000; //60s
      editor.config.uploadImgServer = window.g.apiUrl + "/system/uploadPicFile";
      editor.config.uploadImgHeaders = {
        "x-token": localStorage.getItem("token"), // 设置请求头
      };
      editor.config.uploadImgHooks = {
        //监听
        timeout: function (xhr, editor) {
          this.$message.error("上传图片超时！");
        },
        customInsert: function (insertImg, result, editor) {
          if (result.code == 0) {
            var url = result.msg;
            insertImg(url);
          }
        },
      };
      editor.config.excludeMenus = ["video", "link", "code"];
      // 配置 onchange 回调函数，将数据同步到 vue 中

      editor.create();
      return editor;
    },
    getData() {
      const courseId = this.mxParams.id;
      getCourseJxsqFormInfo({ courseId, reviewTimes: "1" }).then((res) => {
        if (res.code == 0) {
          this.baseInfo = res.data.courseInfo;
          this.feedbackList = res.data.feedbackList;
          if (this.feedbackList.length > 0) {
            this.baseInfo.feedbackType = "1";
          }
        }
      });
    },

    saveForm() {
      const temp = [];
      for (let i of this.editorList) {
        temp.push(i.txt.html());
      }
      let txtIndex = 0;
      for (let i in this.baseInfo.metaPropList) {
        if (this.baseInfo.metaPropList[i].type == 2) {
          this.baseInfo.metaPropList[i].propValue = temp[txtIndex];
          txtIndex = txtIndex + 1;
        }
        if (
          this.baseInfo.metaPropList[i].required == "1" &&
          !this.baseInfo.metaPropList[i].propValue
        ) {
          this.$message.error("请输入" + this.baseInfo.metaPropList[i].cname);
          return;
        }
      }
      insertClosingInfo({ ...this.baseInfo, reviewTimes: "1" }).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.$emit("getParentForm");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleToDownload() {
      this.$router.push({
        name: "courseFile",
        query: { ktsx: this.mxParams.group + "", wjlx: "2", ssjd: "6" },
      });
    },
    handleToUpload() {
      const row = { id: this.baseInfo.courseId, step: 17 };
      this.handleView(row);
    },
    handleView(row) {
      this.handleResultDialog = true;
      this.mxParams = { ...this.mxParams, ...row };
    },
  },
};
</script>

<style lang="less" scoped>
.card {
  //   border-bottom: 2px solid #f3f3f3;
  .label {
    font-size: 16px;
    font-weight: bold;
    height: 44px;
    line-height: 44px;
    padding-left: 15px;
  }
  .card_content {
    padding: 0 30px;
    > div {
      height: 42px;
      line-height: 42px;
      > span:nth-of-type(1) {
        margin-right: 30px;
      }
    }
  }
}
.card:nth-of-type(1) {
  margin-top: 0;
}
.result_content {
  border: 1px solid #ddd;
  line-height: 32px;
  .label {
    line-height: 42px;
    font-size: 16px;
    background-color: #f3f3f3;
    padding-left: 15px;
  }
  .text {
    padding: 15px;
  }
}
.card3 {
  .card3_label {
    margin-left: 120px;
    height: 44px;
    line-height: 44px;
    font-weight: bold;
    font-size: 15px;
  }
}
.card4 .card4_div {
  margin-top: 15px;
  padding: 0 30px;
}
.content {
  margin-bottom: 30px;

  .content_title {
    font-weight: 700;
    margin-bottom: 15px;
  }
  .content_text {
    padding: 5px 15px;
    margin-right: 15px;
  }
}
.red {
  color: #ff0000;
  margin-right: 5px;
}
.btn {
  position: fixed;
  right: 120px;
  z-index: 100001;
}
</style>